import React from "react";
import classNames from "classnames";
import * as styles from "./styles.module.scss";
import PropTypes from "prop-types";

/**
 * ButtonsContainer is a wrapper component for buttons.
 * @param {object} props The properties given to the container div.
 * @param {string} props.className Additional class name to be added to the container.
 * @returns {Element} The container element.
 */
const ButtonsContainer = ( { className = "", ...otherProps }  ) => {
	return <div className={ classNames( styles.buttonsContainer, className ) } { ...otherProps } />;
};

ButtonsContainer.propTypes = {
	className: PropTypes.string,
};

export default ButtonsContainer;
